import { TableDataType } from 'module/ui/components/atoms/rich-text-editor/toolbar/table-toolbar';
import {
  AnswerTypeOption,
  CustomSectionAttributes,
  CustomSectionContentState,
  CustomSectionState,
  CustomSectionType,
  GenerateAsOption,
  GroupByOption,
  ParticipantGroupOption,
  SignalOption,
} from 'api/custom-section/types';
import { AnswerLength } from 'api/custom-section/types/multi-question';
import { v4 as uuidv4 } from 'uuid';

export const defaultCustomSectionNodeConfig: Record<
  CustomSectionType,
  CustomSectionAttributes
> = {
  [CustomSectionType.Question]: {
    title: '',
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.Question,
    config: {
      question: '',
      groupBy: GroupByOption.Topics,
      generateAs: GenerateAsOption.Paragraph,
      participants: ParticipantGroupOption.All,
    },
  },
  [CustomSectionType.Action]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.Action,
    title: '',
    config: {
      groupBy: GroupByOption.Participants,
      generateAs: GenerateAsOption.Checklist,
      participants: ParticipantGroupOption.All,
    },
  },
  [CustomSectionType.ExtractInfo]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.ExtractInfo,
    title: '',
    config: {
      question: '',
      choices: {
        answerType: AnswerTypeOption.SingleChoice,
        choices: [],
        generateNewChoices: false,
      },
    },
  },
  [CustomSectionType.MultiQuestion]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.MultiQuestion,
    title: '',
    config: {
      questions: [
        {
          question: '',
          dataType: TableDataType.TEXT,
          id: uuidv4(),
        },
      ],
    },
  },
  [CustomSectionType.RecordBlock]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.RecordBlock,
    title: '',
    config: {
      aiContext: '',
      rowCriteria: '',
      filterExclusionCriteria: '',
    },
  },
  [CustomSectionType.TableDetails]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.TableDetails,
    title: '',
    config: {},
  },
  [CustomSectionType.SignalDetails]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.SignalDetails,
    config: {
      signalOption: SignalOption.ALL,
      signalConfigurationIds: [],
    },
  },
  [CustomSectionType.MeetingDetails]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.MeetingDetails,
    title: '',
    config: {
      fields: ['meetingName', 'participants'],
    },
  },
  [CustomSectionType.AccountDetails]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.AccountDetails,
    title: '',
    config: {
      fields: [],
    },
  },
  [CustomSectionType.CompanyPageSourceDerivedSection]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.CompanyPageSourceDerivedSection,
    title: '',
    config: {
      groupBy: GroupByOption.Topics,
      generateAs: GenerateAsOption.Paragraph,
      sourcePageTemplateSections: [],
    },
  },
  [CustomSectionType.CustomTextSection]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.CustomTextSection,
    title: '',
    config: {
      content: [],
    },
  },
  [CustomSectionType.PeoplePageSourceDerivedQuestionSection]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.PeoplePageSourceDerivedQuestionSection,
    title: '',
    config: {
      question: '',
      groupBy: GroupByOption.Topics,
      generateAs: GenerateAsOption.Bullet,
      sourcePageTemplates: [],
    },
  },
  [CustomSectionType.PeoplePageSourceDerivedSignalSection]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.PeoplePageSourceDerivedSignalSection,
    title: '',
    config: {
      groupBy: GroupByOption.Topics,
      generateAs: GenerateAsOption.Bullet,
      sourceSignalConfigurations: [],
      sourcePageTemplates: [],
    },
  },
  [CustomSectionType.EmailDetails]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Open,
    sectionType: CustomSectionType.EmailDetails,
    title: '',
    config: {
      fields: ['subject', 'firstEmail', 'latestReply', 'participants'],
    },
  },
  [CustomSectionType.QuestionAnswerItem]: {
    contentState: CustomSectionContentState.Prompt,
    state: CustomSectionState.Closed,
    sectionType: CustomSectionType.QuestionAnswerItem,
    title: '',
    config: {
      question: '',
      answer: '',
      dataType: TableDataType.TEXT,
      answerLength: AnswerLength.TwentyWords,
      answerFrom: '',
    },
  },
};
